<template>
  <div>
    <div class="mail-box-header">
      <form class="row" v-on:submit.prevent="relateUser()">
        <div class="col-lg-4">
          <div class="input-group col-lg-12">
            <input
              type="text"
              class="form-control"
              placeholder="buscar pelo cpf"
              v-model="cpf"
              @blur="searchByCpf"
            />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="input-group col-lg-12">
            <input
              type="text"
              class="form-control"
              placeholder="Tolerancia"
              v-model="continuousTolerance"
            />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="input-group-btn col-lg-12">
            <button
              type="submit"
              class="btn btn-sm btn-primary"
              :disabled="!selectedSchedule || !hasConsumer"
            >
              <i class="fa fa-send"></i>
              Salvar
            </button>
          </div>
        </div>
      </form>
    </div>
    <div v-if="hasConsumer">
      <h4 class="info-text">
        O usuário {{ consumer.fullName
        }}<span>{{
          isRelated ? ' está relacionado' : ' NÃO está relacionado'
        }}</span>
        com a agenda selecionada.
      </h4>
    </div>
    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead class="table-head">
          <tr>
            <th>Nome</th>
            <th>CPF</th>
            <th>
              relacionado<br />
              com agenda
            </th>

            <th></th>
          </tr>
        </thead>

        <tbody class="table-list">
          <tr v-for="(user, key) in conusmerList" :key="key">
            <td>{{ user.fullName }}</td>
            <td>{{ user.cpf }}</td>

            <td @click.prevent="relateUser(user.userToken)">
              <switches
                v-model="user.tariffSchedule"
                theme="bootstrap"
                color="success"
                :emit-on-mount="false"
              ></switches>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Switches from 'vue-switches';
export default {
  components: { Switches },
  props: {
    selectedSchedule: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      cpf: '',
      continuousTolerance: '',
      selectedUser: '',
      conusmerList: [],
      consumer: '',
      hasConsumer: false,
    };
  },
  computed: {
    isRelated() {
      return (
        String(this.consumer.tariffSchedule) === String(this.selectedSchedule)
      );
    },
  },

  mounted() {
    this.listConsumers();
  },
  watch: {
    'searchForm.form.fullName'() {
      this.searchRegister();
    },
    selectedSchedule() {
      this.listConsumers();
    },
  },
  methods: {
    async listConsumers() {
      if (!this.selectedSchedule) {
        return;
      }
      const employeeList = await this.$store.dispatch(
        'CONSUMER/GetConsumerBySchedule',
        {
          scheduleId: this.selectedSchedule,
        },
      );
      this.conusmerList = employeeList;
    },
    async searchByCpf() {
      if (!this.cpf) {
        return;
      }
      const consumer = await this.$store.dispatch('CONSUMER/GetByCpf', {
        cpf: this.cpf,
      });

      this.consumer = consumer;
      this.hasConsumer = true;
    },
    async relateUser(userToken) {
      try {
        if (!userToken && !this.consumer) {
          this.$toasted.error('Selecione um usuário válido');
        }
        await this.$store.dispatch('RELATE/RelateUser', {
          tariffScheduleId: this.selectedSchedule,
          userToken: userToken || this.consumer.userToken,
          continuousTolerance: this.continuousTolerance || null,
        });
        await this.listConsumers();
        this.$toasted.success('Usuário relacionado com sucesso!');
      } catch (error) {
        this.$toasted.error('Não foi possível relacionar usuário');
      }
    },
  },
};
</script>